export default __webpack_public_path__ + "static/media/green_up.fdf1f67b.svg";